import { Container, GridWrapper } from '@sainsburys-tech/luna-grid'
import { useNavigate, useLocation } from 'react-router-dom';
import { Key, useEffect } from 'react'
import useCurrentStore from '../../hooks/useCurrentStore'
import Loading from '../Loading'
import { Card } from '@sainsburys-tech/luna-card'
import ErrorMessage from '../ErrorMessage'
import useIncidents from '../../hooks/useIncidents'
import IncidentCard from '../Card/Cards/IncidentCard'
import { Pagination } from '@sainsburys-tech/luna-pagination'
import { IIncidentDetails } from '../../types'
import { IPagination } from '../../types/Pagination/IPagination'

const Incidents = () => {
  const navigate = useNavigate()
  const storeCode = useCurrentStore().storeCode
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const currentPage = parseInt(searchParams.get('page') ?? "1") - 1;
  let incidentsData: IIncidentDetails[] | undefined = []
  let pagination: IPagination | undefined

  const [incidentsResource, incidentsLoader] = useIncidents()

  useEffect(() => {
    incidentsLoader.current(currentPage, storeCode)
  }, [incidentsLoader, storeCode, currentPage])

  if (incidentsResource.hasLoaded && !incidentsResource.hasError) {
    const incidentsResponse = incidentsResource.data
    pagination = incidentsResponse?.metadata?.pagination
    incidentsData = incidentsResponse?.results
  }

  if (!incidentsResource.hasLoaded && !incidentsResource.hasError && !incidentsResource.noContent)
    return (
      <Container size="xs">
        <Card id="s-loadingElement" className="ln-u-text-align-center">
          <Loading size="large" />
        </Card>
      </Container>
    )

  if (
    incidentsResource.hasError ||
    !incidentsData ||
    incidentsData?.length <= 0 ||
    incidentsResource.noContent
  )
    return (
      <Container size="xs">
        <ErrorMessage errorMessage="No Reported Incidents Were Found" />
      </Container>
    )

  return (
    <>
      <Container className="s-reported-accidents-list" size="xs">
        <GridWrapper
          id="s-reported-accident-cards"
          matrix
          gutterSize="sm"
          className="ln-o-grid--gutter-zero@max-mobile"
        >
          {incidentsData.map((incident: IIncidentDetails, index: Key) => (
            <IncidentCard key={index} incident={incident} />
          ))}
        </GridWrapper>
      </Container>

      {pagination && (
        <Pagination
          id="s-pagination-bar"
          className="ln-u-text-align-center ln-u-margin-ends*3"
          showFirstAndLast
          current={pagination.currentPage}
          total={pagination.totalPages}
          onChange={(page: number, e: any) => {
            e.preventDefault()
            navigate(`?page=${page}`);
          }}
        />
      )}
    </>
  )
}

export default Incidents
